import React from 'react'
import images from 'Assets/Images'
import { DropzoneV2 } from './../DropzoneV2'

const DropzoneWithUrlV2Unstyled = props => {
  var value = (props.input || {}).value || props.value
  return (
    <div>
      {props.label && <label>{props.label}</label>}
      {value ? (
        <a href={value} target="_blank" rel="noreferrer">
          <img className="icon" src={images.openInNewWindowIcon} alt="icon" />
        </a>
      ) : null}
      <DropzoneV2 {...props} accept={'application/pdf'} />
    </div>
  )
}

export { DropzoneWithUrlV2Unstyled }
